import React, { useState } from 'react';
import './NewPasswordForm.css';
import image from './touche logo.png';
import settings from 'config/settings';

const NewPasswordForm: React.FC = () => {
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        setError('');

        try {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');

            if (!token) {
                throw new Error('Token not found in URL');
            }

            const apiUrl = `${settings.userApi}/user/resetPassword/${encodeURIComponent(token)}`;

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ newPassword }),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(errorResponse.message || 'Failed to reset password. Please try again.');
            }

            const successResponse = await response.json();
            setSuccess(successResponse.data.body);

            setTimeout(() => {
                setSuccess('');
                setNewPassword('');
                setConfirmPassword('');
            }, 5000);
        } catch (err) {
            if (err instanceof Error) {
                setError(err.message || 'Something went wrong. Please try again.');
            } else {
                setError('An unknown error occurred.');
            }
        }
    };

    const isButtonDisabled = newPassword.trim() === '' || confirmPassword.trim() === '';

    return (
        <div className="container">
            <div style={{ width: '400px' }}>
                <h2 style={{ marginBottom: '20px' }}>Reset Password</h2>
                <div style={{ marginBottom: '50px', marginTop: '50px' }}>
                    <img width={315} height={75} src={image} alt="Touche Logo" />
                </div>
                <form onSubmit={handleSubmit} className="form">
                    <div className="input-group">
                        <input
                            className='input1'
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <svg
                            width="24"
                            height="31.5"
                            fill={newPassword.trim() === "" ? "rgba(216, 216, 216, 0.101961)" : "#39abf2"}
                            className="input-icon"
                        >
                            <path d="M21 31.5H3a3 3 0 01-3-3v-15a3 3 0 013-3h1.5v-3a7.5 7.5 0 1115 0v3H21a3 3 0 013 3v15a3 3 0 01-3 3zm-18-18v15h18v-15zM12 3a4.505 4.505 0 00-4.5 4.5v3h9v-3A4.505 4.505 0 0012 3zm0 21a3 3 0 113-3 3 3 0 01-3 3z"></path>
                        </svg>
                    </div>
                    <div className="input-group">
                        <input
                            className='input1'
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <svg
                            width="24"
                            height="31.5"
                            fill={confirmPassword.trim() === "" ? "rgba(216, 216, 216, 0.101961)" : "#39abf2"}
                            className="input-icon"
                        >
                            <path d="M21 31.5H3a3 3 0 01-3-3v-15a3 3 0 013-3h1.5v-3a7.5 7.5 0 1115 0v3H21a3 3 0 013 3v15a3 3 0 01-3 3zm-18-18v15h18v-15zM12 3a4.505 4.505 0 00-4.5 4.5v3h9v-3A4.505 4.505 0 0012 3zm0 21a3 3 0 113-3 3 3 0 01-3 3z"></path>
                        </svg>
                    </div>
                    
                    {error && <p style={{ marginBottom: "20px" }} className="error">{error}</p>}
                    {success && <p style={{ marginBottom: "20px" }} className="success">{success}</p>}

                    <button type="submit" disabled={isButtonDisabled}>Submit</button>
                </form>
            </div>
        </div>
    );
};

export default NewPasswordForm;
